export default __webpack_public_path__ + "static/media/moss-on-wall.33a3469a.jpg";